module.exports = __webpack_public_path__ + "img/cimb_niaga_syariah.fc705a82.svg";